import { render, staticRenderFns } from "./MonthlyAnalytics.vue?vue&type=template&id=5826e3af&scoped=true&"
import script from "./MonthlyAnalytics.vue?vue&type=script&lang=js&"
export * from "./MonthlyAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyAnalytics.vue?vue&type=style&index=0&id=5826e3af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5826e3af",
  null
  
)

export default component.exports